export default __webpack_public_path__ + "static/2305-aa08d3a165d9e49ef6156cacc937cc90.gif";